import React from 'react';
import {
    Button,
    Collapse,
    Divider,
    IconButton,
    ListItem,
    ListItemText,
    ListItemSecondaryAction,
    Menu,
    MenuItem,
    Paper,
    Theme,
    Typography,
    withTheme, 
    WithTheme 
} from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import { createStyles, withStyles, WithStyles } from '@material-ui/styles';
import AddressDeleteModal from './DeleteModal';
import AddressEditModal from './AddEditModal';
import { IReturn as Address } from '../../api/resources/Address';

const styles = (theme: Theme) =>
    createStyles({
        content: {
            padding: '8px 16px',
        },
        itemActions: {
            display: 'flex',
            justifyContent: 'flex-end',
        }
    });

interface IProps {
    index: number;
    address: Address;
};

interface IState {
    anchorEl?: React.ReactNode;
    expanded: boolean;
    showDeleteModal: boolean;
    showEditModal: boolean;
}

type FullProps = IProps & WithStyles<typeof styles> & WithTheme;
class AddressItem extends React.PureComponent<FullProps, IState> {
    public state = {
        anchorEl: null,
        expanded: false,
        showDeleteModal: false,
        showEditModal: false,
    }
    
    render() {
        const { index, address, classes } = this.props;
        const { anchorEl, expanded, showDeleteModal, showEditModal } = this.state;

        return (
            <React.Fragment>
                {index != 0 && (
                <Divider component="li" />
                )}
                <ListItem>
                    <ListItemText primary={(
                        <>{address.street1} {address.street2}</>
                    )} secondary={(
                        <>{address.city}, {address.state} {address.zip_code}</>
                    )}/>
                    <ListItemSecondaryAction>
                        <IconButton onClick={this.handleExpandMenu}>
                            <MoreVert />
                        </IconButton>
                    </ListItemSecondaryAction>
                </ListItem>
                <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={expanded}
                    onClose={this.handleCloseMenu}
                >
                    <MenuItem onClick={this.handleEditClick}>Edit</MenuItem>
                    <Divider />
                    <MenuItem onClick={this.handleDeleteClick}>Delete</MenuItem>
                </Menu>
                <AddressDeleteModal address={address} open={showDeleteModal} onDismiss={this.handleDeleteDismiss} />
                <AddressEditModal address={address} open={showEditModal} onDismiss={this.handleEditDismiss} />
            </React.Fragment>
        )
    }

    private handleExpandMenu = (event: React.MouseEvent) => {
        this.setState({
            anchorEl: event.target, 
            expanded: true
        });
    }

    private handleCloseMenu = () => {
        this.setState({expanded: false});
    }

    private handleDeleteClick = () => {
        this.setState({
            expanded: false, 
            showDeleteModal: true
        });
    }

    private handleDeleteDismiss = (shouldRefresh: boolean) => {
        this.setState({showDeleteModal: false});
    }

    private handleEditClick = () => {
        this.setState({
            expanded: false,
            showEditModal: true
        });
    }

    private handleEditDismiss = (shouldRefresh: boolean) => {
        this.setState({showEditModal: false});
    }
}

export default withTheme(withStyles(styles)(AddressItem));